const pad = (n: number) => String(n).padStart(2, "0");

export const isoDate = (d: Date) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

/** 2026.11.30 */
export const formatDotDate = (d: Date) => isoDate(d).replaceAll("-", ".");

/** 2026.11.30(월) */
export const formatDeadline = (d: Date) =>
  `${formatDotDate(d)}(${"일월화수목금토"[d.getDay()]})`;

/** 형식이 정확히 맞고 왕복이 되는 날짜만 통과시킨다(2026.02.30 은 3/2 가 되므로 탈락) */
const parseExact = (
  text: string,
  pattern: RegExp,
  format: (d: Date) => string,
): Date | null => {
  const m = pattern.exec(text.trim());
  if (!m) return null;
  const d = new Date(+m[1], +m[2] - 1, +m[3]);
  return format(d) === text.trim() ? d : null;
};

/**
 * API 의 YYYY-MM-DD 를 로컬 자정으로 읽는다. new Date("2026-11-30") 은 UTC 라 서쪽
 * 시간대에서 하루 밀린다. 형식이 어긋나면 null — 호출부가 "마감일 없음" 으로 다룬다
 */
export const parseIsoDate = (text: string | null | undefined): Date | null =>
  parseExact(text ?? "", /^(\d{4})-(\d{2})-(\d{2})$/, isoDate);

/** YYYY.MM.DD 가 아니거나 없는 날짜(2026.02.30)면 null */
export const parseDotDate = (text: string): Date | null =>
  parseExact(text, /^(\d{4})\.(\d{2})\.(\d{2})$/, formatDotDate);

/** 마감일 당일은 D-Day. today 에 시각이 섞여 있어도 자정 기준으로 센다 */
export const dDay = (deadline: Date, today: Date) => {
  const midnight = new Date(today);
  midnight.setHours(0, 0, 0, 0);
  const days = Math.round(
    (deadline.getTime() - midnight.getTime()) / 86_400_000,
  );
  return days === 0 ? "D-Day" : days > 0 ? `D-${days}` : `D+${-days}`;
};
